<script>
    import Pagination from 'vue-pagination-2';
    import template from './template.html';
    import VtPerPageSelector from 'vue-tables-2/compiled/components/VtPerPageSelector';

    export default {
        name: "VtPagination",
        components: {
            Pagination,
            VtPerPageSelector,
        },
        template,
        props: ['props'],

        watch: {
          'props.opts.totalPages': function (val) {
            this.dataReady = false;
            this.props.records = val;

            setTimeout(() => {
            }, 300)
          }
        },
        updated () {
          //this.props.records = this.props.opts.totalPages;
          //this.dataReady = false;
        },
        data () {

          return {
            dataReady: true
          }
        }
    }
</script>
